
import { useState } from 'react';

import { Link } from 'react-router';

import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { FaBook } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle, MenuItemLibrosStyle, TypographyAppBarStyle } from '../../styles/ListItemStyle';

export const ListItemLibrosElectronicos = () => {

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
    
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (

        <>
        
            <ListItemText style={ ListItemTextStyle }>
            
                    <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                        <FaBook style={ ListItemIconStyle } />

                        <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                            Libros electrónicos
                        </Typography>     

                        <FaChevronDown style={ ListItemIconStyle } />  
                    </Button>

            </ListItemText>

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
            >
                
                <Link to="/libros-electronicos/libro-registro" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de registro <strong>(Libro de gobierno)</strong></ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-auxiliar" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de promociones irregulares y <br /> expedientillos auxiliares</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-amparos" style={{ textDecoration: 'none' }}>                
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de amparos</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-exhortos-librados" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de exhortos librados</ListItemText>
                    </MenuItem>              
                </Link>
                
                <Link to="/libros-electronicos/libro-exhortos-recibidos" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro exhortos recibidos</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-actuarios" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de actuarios</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-expedientes-concluidos" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de expedientes concluidos</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-citados-sentencia-definitiva" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de negocios citados para sentencia <br /> definitiva y resueltos</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-citados-sentencia-interlocutoria" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de negocios citados para sentencia <br /> interlocutoria y resueltos</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-promociones-recibidas" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de promociones recibidas</ListItemText>
                    </MenuItem>
                </Link>

                <Link to="/libros-electronicos/libro-indice-alfabetico" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de índice alfabético</ListItemText>
                    </MenuItem>        
                </Link>   
                
                <Link to="/libros-electronicos/libro-medios-impugnacion" style={{ textDecoration: 'none' }}>
                    <MenuItem sx={{ ...MenuItemLibrosStyle, py: 2 }} onClick={ handleClose } > 
                        <ListItemIcon> <FaBook /> </ListItemIcon>
                        <ListItemText style={TypographyAppBarStyle}>Libro de medios de impugnación</ListItemText>
                    </MenuItem>        
                </Link>                      

            </Menu>
        
        </>
        
    )
}